import React from "react";
import SharedSwitchWhatsApp from "../../../../../components/whatsapp/SwitchWhatsApp";

const AdminSwitchWhatsApp = () => (
  <SharedSwitchWhatsApp basePath="/dashboard/admin/menu/whatsapp" />
);

export default AdminSwitchWhatsApp;
